import React, {useState} from "react";
import { Formik } from "formik";
import ThemeModal from "../../../components/cmp/ThemeModal";
import CreateUserForm from "../../../components/users/CreateUserForm";
import { GetUser, Alerts } from "../../../helpers";
import OtpTimer from "../../../components/OTP/OtpTimer";
import { Spinner } from "react-bootstrap";
import OtpInput from 'react-otp-input';
import { FaPlus   } from "react-icons/fa";
const AddNewUser = ({setcQuery})=>{
      const [isLoading, setLoading] = useState(false);
      const [isNew, setNew] = useState(false);
      const [verificationEmail, setVericationEmail] = useState('')
      const [isOtp, setOtp] = useState(false);
      const [isExpired, setExpired] = useState(false);
      const [resendLoading, setResendLoading] = useState(false);

      const handleOtpExpired = () => {
        setExpired(true);
      };


        const handleSubmit = async (values, { setSubmitting, resetForm }) => {
          const resp = await GetUser.addNewUser(values);
          if (resp && resp.status) {
            setVericationEmail(resp.email);
            setOtp(true);
            setSubmitting(false);
            resetForm();
           
          } else {
            setSubmitting(false);
          }
        }
        const verifyOtp = async (values, { setSubmitting, resetForm }) => {
          setLoading(true)
          values.email = verificationEmail;
          const resp = await GetUser.verifyNewUser(values);
          if (resp && resp.status) {
            setcQuery(verificationEmail);
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            setOtp(false);
            setNew(false);
            setVericationEmail('');
            setLoading(false)
          } else {
             setSubmitting(false);
             setLoading(false)
          }
        }
      
        const skipAndCountineu = () => {
          setOtp(false);
          setNew(false);
          setVericationEmail('');
          Alerts.alertMessage('Customer added successfully without verification', 'top-right', 'success');
        }
      
      
        const resentOtp = async (email) => {
          setResendLoading(true);
          let resp = await GetUser.resentOtp({ email: email });
          if (resp) {
            setResendLoading(false);
            setExpired(false);
          }
        }
   return (
    <>
       <button className="addUserBtn" onClick={()=>setNew(true)}><FaPlus style={{fontSize:10}}/> Add New</button>
       <ThemeModal show={isNew} handleHide={() => setNew(false)} title={'Add New User'} isHeader={true} size="lg">
            {
              isOtp ? <div style={{ maxWidth: 300, margin: '25px auto' }}>
                <Formik
                  initialValues={{ otp: "" }}
                  validate={(values) => {
                    const errors = {};
                    if (!values.otp) {
                      errors.otp = "OTP is required !";
                    } else if (values.otp.length !== 6) {
                      errors.otp = "OTP should be 6 digit.";
                    } else if (isNaN(values.otp)) {
                      errors.otp = "OTP should be digits.";
                    }
                    return errors;
                  }}
                  onSubmit={verifyOtp}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue

                  }) => (
                    <form onSubmit={handleSubmit}>
                      <h5 style={{ textAlign: 'center' }}>Verify with OTP</h5>
                      <p style={{ textAlign: 'center', marginBottom: 15, fontSize: 14 }}>Sent to : {verificationEmail} </p>
                      <OtpInput
                        value={values.otp}
                        onChange={(otp) => setFieldValue('otp', otp)}
                        numInputs={6}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                        containerStyle={{ justifyContent: 'space-between' }}
                        inputStyle={{
                          width: '40px',
                          height: '40px',
                          fontSize: '18px',
                          borderRadius: '4px',
                          border: '1px solid #ccc',
                        }}
                      />
                      {errors.otp && touched.otp && (
                        <div style={{ textAlign: 'center' }}>
                          <span className="helpError">{errors.otp}</span>
                        </div>

                      )}
                      {
                        resendLoading ? <div style={{ textAlign: 'center', marginTop: 10 }}><Spinner animation="border" variant="dark" size="sm" /> Please wait.. </div> : <>
                          <div style={{ textAlign: 'center', marginBottom: 15, marginTop: 10 }}>
                            {!isExpired ? <OtpTimer duration={600} onExpire={handleOtpExpired} /> : <div className={'resendOtp'}>
                              <p>If you didn't receive OTP :</p> <button type="button" onClick={() => resentOtp(verificationEmail)} >Resend</button>
                            </div>}
                          </div>

                          <div style={{ margin: '0px auto 15px', display: "flex", alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                            <button className="btn btn-primary " type="submit" disabled={isLoading} style={{ fontSize:14 }}>
                              {isLoading ? <><Spinner animation="border" variant="dark" size="sm" /> <span>Please wait..</span>  </> : 'Continue'}
                            </button>
                            <button className="btn btn-default" style={{ fontSize:14 }} type="button" disabled={isLoading} onClick={skipAndCountineu}>
                              Skip & Continue
                            </button>
                          </div>
                        </>
                      }


                    </form>
                  )}
                </Formik>
              </div> :
                <CreateUserForm handleSubmit={handleSubmit} />

            }
          </ThemeModal>
    </>

   )
}
export default AddNewUser;